import { Stamp } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";

const TrademarkRegistration = () => {
  const mainContent = (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">Trademark Registration Services</h2>
          <p className="text-lg text-muted-foreground">
            Federal and state trademark registration to protect your brand, logo, and business identity. We conduct comprehensive trademark searches, file applications with USPTO, and defend your intellectual property rights.
          </p>
        </div>
      </div>
    </section>
  );
  return <GenericPracticePage title="Trademark Registration" subtitle="Protect Your Brand Identity" icon={<Stamp className="h-16 w-16" />} mainContent={mainContent} />;
};
export default TrademarkRegistration;